import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useLanguage } from "../language/LanguageConfig";
import { Language } from "./context";
const LanguageSync = ({ children }) => {
  const { lang } = useParams(); // URL에서 lang 파라미터 추출
  const { lang: currentLang, setLang } = useLanguage();

  const nav = useNavigate();

  useEffect(() => {
    const validLangs = Object.values(Language);

    // 언어가 유효하지 않으면 홈으로 리디렉션
    if (!validLangs.includes(lang)) {
      nav(`/${currentLang}` || `/${Language.KOREAN}`);
      return;
    }

    if (lang !== currentLang) {
      setLang(lang);
    }
  }, [lang]);

  return <>{children}</>;
};

export default LanguageSync;
